import { FreedataValueVO as BaseFreedataValueVO, IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { FreeDataValue, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { FreeDataVO } from './freedata.vo';
import { Observable } from 'rxjs';
import { Model } from '../../model/model';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { ViewData } from '../../model/view.data';

@entity('wizeoo.allkeyme.core.message.FreeDataValue', 'BU')
export class FreedataValueVO extends BaseFreedataValueVO implements IVo {

  constructor(model: Model, pSource?: FreeDataValue) {
    super(model, pSource);
    this.byWidgetStringMap = null;
  }

  public get id(): number {
    return this.source.id;
  }

  public set id(id: number) {
    this.source.id = id;
  }
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(uid: string) {
    this.source.uid = uid;
  }

  public set domain(domain: string) {
    this.source.domain = domain;
  }

  public get domain(): string {
    return this.source.domain;
  }

  /**  */
  public set businessUnitCode(businessUnitCode: string) {
    this.source.businessUnitCode = businessUnitCode;
  }
  public get businessUnitCode(): string {
    return this.source.businessUnitCode;
  }

  /** Parent pour le tree */
  public get treeParentCode(): string {
    return this.parentCode ? this.parentCode : '## ' + this.freeDataCode + ' ##';
  }

  // Id technique du freeData (pour maj autonome des FDVs)
  public get fdid(): number {
    return this.source.fdid;
  }
  public set fdid(value: number) {
    this.source.fdid = value;
  }

  /** Code FD externe */
  @field('string')
  public set externalFreedataCode(code: string) {
    this.source.externalFreedataCode = code;
  }
  public get externalFreedataCode(): string {
    return this.source.externalFreedataCode;
  }

  /** Code parent externe */
  @field('string')
  public set externalParentCode(code: string) {
    this.source.externalParentCode = code;
  }
  public get externalParentCode(): string {
    return this.source.externalParentCode;
  }

  /** Code externe */
  @field('string')
  public set externalCode(code: string) {
    this.source.externalCode = code;
  }
  public get externalCode(): string {
    return this.source.externalCode;
  }

  /**  */
  public set deletable(deletable: boolean | null) {
    this.source.deletable = deletable;
  }

  public get deletable(): boolean | null {
    return this.source.deletable;
  }


  /**  */
  public set chronoCode(code: string) {
    this.source.chronoCode = code;
  }

  @field('string')
  public get chronoCode(): string {
    return this.source.chronoCode;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
    this._labelVO = null;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
    this._descriptionVO = null;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  public get deleted(): boolean {
    return this.source.deleted;
  }
  public set deleted(value: boolean) {
    this.source.deleted = value;
  }

  @field('string')
  public get icon(): string {
    return this.source.icon;
  }
  public set icon(pValue: string) {
    this.source.icon = pValue;
  }

  public get version(): number {
    // technique
    return this.source.version;
  }
  public set version(value: number) {
    this.source.version = value;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */


  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /**
   * retourne le libellé avec le parent en suffixe
   */
  public get trsLabelWithParent(): string {
    let result: string = Model.getInstance().localeEngine.translate(this.label, this.code);
    if (this.getParentVO()) {
      result = result + ' (' + this.getParentVO().trsLabel + ')';
    }
    return result;
  }

  private _codeByLevel: string[] = null;
  /**
   * retourne le code décomposé par niveau
   * permet un filtre rapide dans les grid FDs
   * TODO attention, c'est le _ qui est utilisé comme séparateur... Pas ouf ouf
   */
  public get codeByLevel(): string[] {
    if (!this._codeByLevel) {
      // construction de la pile pour le FDV
      let meCode: string[] = [];
      meCode.push(this.code);
      const daddy: FreedataValueVO = this.getParentVO();
      if (daddy) {
        meCode = daddy.codeByLevel.concat(meCode);
      }
      this._codeByLevel = meCode;
    }
    return this._codeByLevel;
  }

  /** Suis-je utilisé? */
  private _used: boolean;
  public get isUsed(): boolean {
    let result: boolean = this._used;
    if (!result && this.getParentFDVO().kindMeasure) {
      result = Model.getInstance().visionEngine.checkMeasureIsUsed(this.domain, this.businessUnitCode, this.freeDataCode, this.code);
    }
    return result;
  }
  public set isUsed(b: boolean) {
    this._used = b;
  }

  /** L'élément est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.source.id > 0;
  }

  /** retourne l'icone si existe, sinon le média par défaut */
  public get iconOrDie(): Observable<string> {
    return AttachmentService.getInstance().iconOrDie(this.icon, this.domain, this.businessUnitCode, ViewData.wildcardMainVision);
  }

  /* ############################################
   *       Collecte des VOs
   * ############################################ */

  // [MOTEUR BACK] On récupére ici des instances "ihm"
  public override getParentVO(): FreedataValueVO {
    return super.getParentVO() as FreedataValueVO;
  }

  public override getParentFDVO(): FreeDataVO {
    return super.getParentFDVO() as FreeDataVO;
  }

  /**
   * map des champs concaténés par |, par uuid de widget, pour recherche par filtre générique
   */
  public byWidgetStringMap: Map<string, string> = null;

}
